var React = require('react');

function AngleDown (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M8.004 12.25L2.233 5.378a.988.988 0 0 1 .126-1.398 1.007 1.007 0 0 1 1.409.127l4.236 5.042 4.229-5.034c.352-.42.98-.478 1.408-.127.424.35.48.977.127 1.398L8.004 12.25z"}));
}

AngleDown.defaultProps = {"viewBox":"0 0 16 16"};

module.exports = AngleDown;

AngleDown.default = AngleDown;
